import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { forkJoin, iif } from 'rxjs';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-skip-day-popup',
  templateUrl: './skip-day-popup.component.html',
  styleUrls: ['./skip-day-popup.component.scss']
})
export class SkipDayPopupComponent implements OnInit {
  skipDayForm: FormGroup = new FormGroup({});
  skipDayFormDate: any = null;
  buttonColorName: any;
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  selectedDate: any;

  constructor(
    private datePipe: DatePipe,
    public sharedService: SharedService,
    private snackBar: MatSnackBar,
    private loadingService: LoaderService,
    public dialogRef: MatDialogRef<SkipDayPopupComponent>,
    private loader: LoaderService,
    private encryptionService: EncryptionService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private httpService: HttpService,
    private config: Config,
    public router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private activatedroute: ActivatedRoute,
    private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,
    private PdfDownload: PdfDownloadService,
    private dataRefreshService: DataRefreshService
  ) {}

  ngOnInit() {
    // console.log('111111111111.........', this.data);
    this.dwmUpdateDataList = this.data.data.map((item: any) => item.id);
    this.selectedDate = this.formatDate(this.data.selectedDay);
    this.skipDayForm = this.fb.group({
      date: [this.selectedDate || new Date(), Validators.required],
      reason: ['', Validators.required]
    });
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    // this.getSkippedDayData();
    this.getDWMUpdateData();
  }

  onDateChangeForSkipDay() {}

  submit() {}

  dwmUpdateDataList: any[] = [];

  getDWMUpdateData() {
    // this.httpService.callGetService(`${this.config.getDwmUpdate}?companyId=${this.loggedInUserCompanyID}`).subscribe((data: any) => {
    // this.dwmUpdateDataList = this.data.data;
    //    console.log("DWM Transaction Data....", this.dwmUpdateDataList)
    // });
  }

  submitForApproval() {
    if (this.skipDayForm.invalid) {
      return;
    }

    // const selectedDate = this.formatDate(this.skipDayForm.value.date);
    const selectedDate = this.formatDate(this.data.selectedDay);
    // this.formatDate(this.data.selectedDay);

    // existing skipped day (for update)
    // const skipRecord = this.skippedDayData.find(d => d.dwmDate === this.selectedDate);

    // DWM transaction id (from DWM list)
    // const transaction = this.dwmUpdateDataList.map(item => item.id);

    // console.log("11111..",this.data.data)
    // console.log("Transaction id ..",transaction)

    let payload: any = [];
    this.data.data.map(
      (item: any) =>
        (payload = [
          ...payload,
          {
            companyId: this.data?.resubmit ? item?.companyId : this.loggedInUserCompanyID,
            id: this.data?.resubmit ? item?.id : null,
            transactionId: this.data?.resubmit ? item?.transactionId : item.id,
            userId: this.data?.resubmit ? item?.userId : this.loggedInUserId,
            managerId: this.data?.resubmit ? item?.managerId : null,
            dwmDate: this.data?.resubmit ? item?.dwmDate : this.selectedDate,
            isSkipped: null,
            reason: this.skipDayForm.value.reason,
            managerComment: this.data?.resubmit ? item?.managerComment : null
          }
        ])
    );
    // console.log('payload is....', payload);

    this.httpService.callPostService(this.config.dwmSkipDay, payload).subscribe({
      next: res => {
        // console.log("Skipped day submitted",res)
        this.dialogRef.close(true);
        // this.getSkippedDayData();
      },
      error: err => {
        console.error('Error while submitting.', err);
      }
    });
  }

  // --------------------------------- Get Skipped data -----------------------

  // skippedDayData: any[] = [];

  // getSkippedDayData() {
  //   this.httpService.callGetService(`${this.config.getSkipDay}?companyId=${this.loggedInUserCompanyID}`).subscribe((data: any) => {
  //     this.skippedDayData = data.data || [];
  //     // console.log('Skipped data:', this.skippedDayData);
  //   });
  // }

  //  ------------------------------------------------ Format Date ---------------------------------------------

  formatDate(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${month}-${day}`;
  }
}
